import service from '../../services/graphQlServices';
export const requestExecutor = async (func,json,vendorID) => {
	let usertoken = localStorage.getItem('usertoken');
	const response = await service.query(func, json, vendorID, usertoken, 'vendors');
	return {
		success: response[0],
		result: response[0] ? response[1].data : response[1].message,
	};
};


